import { Grid } from "antd";

const { useBreakpoint } = Grid;

const useIsMobile = () => {
  const screens = useBreakpoint();

  return !screens.md;
};

export default useIsMobile;
